module.exports = __webpack_public_path__ + "static/media/reth-circle.86cd30a9.png";